<div class="profile-root d-flex align-items-center ms-3">
  <div class="profile-left d-flex align-items-center flex-shrink-1" style="min-width: 0;">
    <div
      class="profile-avatar profile-avatar-generated d-flex justify-content-center align-items-center"
      [ngStyle]="{ 'background-color': avatarBgColor, color: avatarTextColor }"
      aria-label="Avatar gerado"
    >
      {{ avatarInitial }}
    </div>
    <div class="profile-text mx-3">
      <div class="profile-name fw-bold">{{ userName }}</div>
      <div class="profile-username text-muted small">{{ userEmail }}</div>
    </div>
  </div>

  <div class="profile-actions ms-auto position-relative">
    <button class="btn btn-link p-0" (click)="toggleMenu()" aria-label="Abrir menu">
      <i class="fa-solid fa-caret-down"></i>
    </button>

    <div class="profile-dropdown card" *ngIf="showMenu">
      <div class="list-group list-group-flush">
        <button class="list-group-item list-group-item-action text-danger" (click)="logout(); $event.preventDefault()">
          <i class="fas fa-sign-out-alt me-2"></i> Sair
        </button>
      </div>
    </div>
  </div>
</div>
